import React from 'react';
import PropTypes from 'prop-types';

const MobileTopNavSmallView = ({ className, onClick, headerText }) => (
  <div className={`${className} mobile-top-nav-small`}>
    <button className="mobile-top-nav-small-back" type="button" onClick={onClick}>
      {onClick && <i className="mobile-top-nav-small-back-i fa fa-caret-left" />}
      <div className="mobile-top-nav-small-text">{headerText}</div>
    </button>
  </div>
);

MobileTopNavSmallView.defaultProps = {
  onClick: null,
  className: '',
};

MobileTopNavSmallView.propTypes = {
  onClick: PropTypes.func,
  headerText: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default MobileTopNavSmallView;
